import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  ViewChild,
  inject,
} from '@angular/core';
import {
  MatBottomSheet,
  MatBottomSheetConfig,
  MatBottomSheetModule,
  MatBottomSheetRef,
} from '@angular/material/bottom-sheet';
import { SharedModule } from '@shared/shared.module';
import { take } from 'rxjs/operators';

@Component({
  selector: 'app-bottom-sheet',
  templateUrl: './bottom-sheet.component.html',
  styleUrls: ['./bottom-sheet.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [SharedModule, MatBottomSheetModule],
})
export class BottomSheetComponent {
  @ViewChild(TemplateRef) template?: TemplateRef<any>;

  @Input() ariaLabelSheet?: string;

  @Output() quitFn = new EventEmitter<void>();

  private matBottomSheetRef?: MatBottomSheetRef;

  readonly #bottomSheet = inject(MatBottomSheet);

  open(config?: MatBottomSheetConfig): void {
    if (!this.template) {
      return;
    }

    this.matBottomSheetRef = this.#bottomSheet.open(this.template, {
      ...config,
      ariaLabel: this.ariaLabelSheet,
    });

    this.matBottomSheetRef
      .afterDismissed()
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.quitFn.emit();
        },
      });
  }

  close(): void {
    this.matBottomSheetRef?.dismiss();
  }
}
